import { ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

export type FlatRowSelectAction = {
	label: string;
	onClick: () => void;
	icon?: ReactNode;
	color?: string;
};

type Props = {
	action: FlatRowSelectAction;
	isLast: boolean;
};

export const FlatRowSelectActionRow: FC<Props> = ({ action, isLast }) => {
	const { palette, spacingTokens, colors } = useTheme();

	return (
		<ButtonBase
			onClick={action.onClick}
			sx={{
				justifyContent: "flex-start",
				gap: spacingTokens.md,
				py: spacingTokens.md,
				textAlign: "left",
				borderBottom: isLast ? "none" : colors.border.solid(palette.grey[100]),
			}}
		>
			{action.icon}
			<Typography
				variant="bodyMedium"
				color={action.color ?? palette.blue[600]}
				flex={1}
			>
				{action.label}
			</Typography>
		</ButtonBase>
	);
};
